// PaintersInsuranceFAQ.ts
// ----------------------------------------------------------------------------
// 10 Frequently Asked Questions for Painters Insurance
// Fields: id, question, answer, category, type
// ----------------------------------------------------------------------------

export interface PaintersInsuranceFAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
  type: string;
}

export const paintersInsuranceFAQs: PaintersInsuranceFAQ[] = [
  {
    id: 1,
    question: "What is painters insurance?",
    answer:
      "Painters insurance is a set of business insurance policies designed to protect painting contractors and their businesses from risks such as property damage, accidents, and liability claims.",
    category: "Basics",
    type: "General",
  },
  {
    id: 2,
    question: "Why do painters need insurance?",
    answer:
      "Painting contractors face risks such as accidental spills, falls, overspray damage, and customer property damage. Insurance protects against lawsuits and financial losses from these incidents.",
    category: "Requirements",
    type: "Risk Management",
  },
  {
    id: 3,
    question: "What types of insurance do painters typically need?",
    answer:
      "Most painters need General Liability Insurance, Workers’ Compensation (if they have employees), Commercial Auto Insurance, and sometimes Tools & Equipment coverage or a Business Owners Policy (BOP).",
    category: "Coverage",
    type: "Policy",
  },
  {
    id: 4,
    question: "Does painters insurance cover accidental damage to a customer’s property?",
    answer:
      "Yes. General Liability Insurance usually covers accidental property damage, such as spilling paint on carpets or overspray on vehicles.",
    category: "Coverage",
    type: "Liability",
  },
  {
    id: 5,
    question: "Is painters insurance required by law?",
    answer:
      "General Liability Insurance may be required by customers or contracts, while Workers’ Compensation is legally required in most states if you have employees.",
    category: "Requirements",
    type: "Legal",
  },
  {
    id: 6,
    question: "How much does painters insurance cost?",
    answer:
      "Costs vary based on location, number of employees, coverage limits, and business size. On average, small painting businesses might pay $400–$1,500 per year for general liability coverage.",
    category: "Cost",
    type: "Financial",
  },
  {
    id: 7,
    question: "Does painters insurance cover employee injuries?",
    answer:
      "Yes, if you have Workers’ Compensation insurance. This policy covers medical expenses and lost wages if employees are injured on the job.",
    category: "Coverage",
    type: "Workers’ Compensation",
  },
  {
    id: 8,
    question: "What about my tools, ladders, and spray equipment?",
    answer:
      "You can add a Tools & Equipment policy or inland marine coverage to protect your painting equipment from theft, damage, or loss on job sites or in transit.",
    category: "Coverage",
    type: "Equipment",
  },
  {
    id: 9,
    question: "Can insurance help me win painting contracts?",
    answer:
      "Yes. Many customers and commercial clients require proof of insurance before awarding jobs. Having painters insurance builds credibility and trust with clients.",
    category: "Business",
    type: "Sales",
  },
  {
    id: 10,
    question: "How do I get proof of painters insurance?",
    answer:
      "Once insured, your provider will issue a Certificate of Insurance (COI), which you can share with clients, landlords, or general contractors.",
    category: "Process",
    type: "Documentation",
  },
];
